import { render, staticRenderFns } from "./ExamplesInput.vue?vue&type=template&id=1c476f16&"
import script from "./ExamplesInput.vue?vue&type=script&lang=js&"
export * from "./ExamplesInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/dev/www/word-trainer-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFadeTransition } from 'vuetify/lib'
installComponents(component, {VBtn,VFadeTransition})
